import React from "react";
const TheoAI: React.FC = () => <></>;
export default TheoAI;
